import React from "react";

const Table = ({ headers, children }) => {
  return (
    <table className="divide-y-1 text-base divide-gray-600 w-full">
      <thead>
        <tr>
          {headers.map((header, index) => (
            <th key={`${index}_${header}`} className="table-th">
              {header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody className="divide-y divide-slate-600/50">{children}</tbody>
    </table>
  );
};

export default Table;
